import React, { useState } from 'react';

export function MobileOptimizedProductImage({ images, title, className = '' }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const [isSwiping, setIsSwiping] = useState(false);

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setIsSwiping(true);
    setTouchEnd(0);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    setIsSwiping(false);
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe && currentIndex < images.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
    if (isRightSwipe && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div className="relative px-4 md:px-0">
      {/* Image indicators */}
      <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 flex gap-2 z-20">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-2 h-2 rounded-full transition-all ${
              index === currentIndex ? 'bg-berleto-warmgray w-6' : 'bg-berleto-sage/30'
            }`}
          />
        ))}
      </div>
      {/* Image Container */}
      <div
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        className="overflow-hidden touch-pan-y relative"
        style={{ opacity: isSwiping ? 0.8 : 1 }}
      >
        {/* All images preloaded and stacked */}
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`${title} view ${index + 1}`}
            className={`w-full ${className || 'max-w-sm md:max-w-md mx-auto'} drop-shadow-xl select-none pointer-events-none transition-opacity duration-200 ${
              index === currentIndex ? 'opacity-100' : 'opacity-0 absolute inset-0'
            }`}
            draggable={false}
            loading="eager"
          />
        ))}
      </div>

      {/* Instructions */}
      <p className="text-center text-sm text-berleto-sage mt-12 opacity-60">
        Swipe or tap dots to rotate
      </p>
    </div>
  );
}